import { render, staticRenderFns } from "./ServiceCZN.vue?vue&type=template&id=e221482e"
import script from "./ServiceCZN.vue?vue&type=script&lang=js"
export * from "./ServiceCZN.vue?vue&type=script&lang=js"
import style0 from "./ServiceCZN.vue?vue&type=style&index=0&id=e221482e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports